import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import SloganBanner from '../components/SloganBanner';
import Services from '../components/Services';
import TrustBadges from '../components/TrustBadges';
import Reasons from '../components/Reasons';
import VideoSection from '../components/VideoSection';
import BeforeAfter from '../components/BeforeAfter';
import Areas from '../components/Areas';
import Testimonials from '../components/Testimonials';
import Steps from '../components/Steps';
import FAQ from '../components/FAQ';
import ContactCTA from '../components/ContactCTA';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import BookingModal from '../components/BookingModal';
import { BookingProvider, useBooking } from '../context/BookingContext';

function HomeInner() {
  const { open, closeModal } = useBooking();
  return (
    <div className="w-full overflow-x-hidden">
      <Header />
      <Hero />
      <SloganBanner />
      <Services />
      <TrustBadges />
      <Reasons />
      <BeforeAfter />
      <VideoSection />
      <Areas />
      <Testimonials />
      <Steps />
      <FAQ />
      <ContactCTA />
      <Footer />
      <WhatsAppButton />
      <BookingModal open={open} onClose={closeModal} />
    </div>
  );
}

export default function Home() {
  return (
    <BookingProvider>
      <HomeInner />
    </BookingProvider>
  );
}
